export default __webpack_public_path__ + "static/media/dreamstime_s_82823450.53aab858.jpg";